const p = (label, value = "") => `<p><b>${label}:</b> ${value}</p>`;
const h = (t) => `<p><b><u>${t}</u></b></p>`;

export const NOTE_TEMPLATES = {
  installazione: {
    targhette_pannelli: [
      p("Numero moduli installati"), p("Marca", "Aiko"), p("Modello"), p("Potenza singolo modulo"),
      p("Potenza totale generatore"), p("Connettori"), p("Struttura di supporto"),
    ].join(""),
    elettrico: [
      h("QUADRI ELETTRICI AC/DC"),
      p("Involucri", "Conformi CEI EN 61439 IP40/IP65"), p("Corrente nominale DG/DDG", "Adeguata"),
      p("Coordinamento protezioni", "Verificato"), p("Identificazione circuiti", "Nello schema unifilare"),
      h("PROTEZIONI LATO AC"),
      p("Interruttore DG"), p("Protezione differenziale DDG"), p("Potere di interruzione", "Conforme CEI EN 60947"),
      p("Coordinamento DG-conduttori", "Verificato Conforme"),
      h("LINEE ELETTRICHE"),
      p("Lato DC"), p("Lato AC"), p("Conduttore PE"), p("Tubo / Diametro"), p("Tipo Posa"),
      h("IMPIANTO DI TERRA"),
      p("Collegamento equipotenziale strutture", "Eseguito"), p("Collegamento a impianto di terra esistente", "Eseguito"),
      p("Continuità conduttore di protezione", "Verificata"), p("Coordinamento con prot. differenziale — Norma", "Conforme CEI 64-8"),
    ].join(""),
  },
};

const isEmpty = (html) => !(html || "").replace(/<[^>]*>/g, "").replace(/&nbsp;/g, " ").trim();
export const initialNotesFor = (module, slug, notes) => (isEmpty(notes) && NOTE_TEMPLATES[module]?.[slug]) || notes || "";
